/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automation_Fixed_Agent_IdInputs */

const cs_automation_fixed_agent_id = /** @type {(inputs: Automation_Fixed_Agent_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID pevného agenta`)
};

const en_automation_fixed_agent_id = /** @type {(inputs: Automation_Fixed_Agent_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fixed agent ID`)
};

/**
* | output |
* | --- |
* | "Fixed agent ID" |
*
* @param {Automation_Fixed_Agent_IdInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const automation_fixed_agent_id = /** @type {((inputs?: Automation_Fixed_Agent_IdInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automation_Fixed_Agent_IdInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_automation_fixed_agent_id(inputs)
	return cs_automation_fixed_agent_id(inputs)
});